module.exports = __webpack_public_path__ + "files/0182029487b788b06bb585046f6129f6.png";